import { render, staticRenderFns } from "./oxQuiz.vue?vue&type=template&id=49b2f5fd&"
import script from "./oxQuiz.vue?vue&type=script&lang=js&"
export * from "./oxQuiz.vue?vue&type=script&lang=js&"
import style0 from "./oxQuiz.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports